import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { FieldControllerProvider } from './FieldControllerContext';
import { FieldGroup } from './FieldGroup';

export type BooleanField = {
    name: string;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    children: React.ReactNode;
};

/**
 * A field for a checkbox or a switch.
 */
export const BooleanField = React.forwardRef(function BooleanField(
    props: BooleanField,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    const { control } = useFormContext();
    const controller = useController({
        control,
        name: props.name,
        rules: { required: props.required ? 'Required' : false },
        disabled: props.disabled,
    });
    return (
        <FieldControllerProvider controller={controller}>
            <FieldGroup ref={ref} orientation="horizontal">
                {props.children}
            </FieldGroup>
        </FieldControllerProvider>
    );
});
